export default {"src":"/_next/static/media/Start_using_xylo.3eb04644.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};